import React from "react";
import "./style.scss";

type ContentHeaderProps = {
  title?: string;
};

export const ContentHeader = (props: ContentHeaderProps) => {
  const { title } = props;
  return (
    <div className="contentHeader">
      <div className="contentHeader_title">
        <span>{title}</span>
        {/* 以下にアコーディオン用のトグルButton */}
      </div>
    </div>
  );
};
